import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Percentage of portfolio capable of being liquidated within',
    order: 206,
    columnLables: {
      liquidity_0_to_1_day: {
        name: '1 day or less',
        letter: 'A'
      },
      liquidity_2_to_7_days: {
        name: '2 - 7 days',
        letter: 'B'
      },
      liquidity_8_to_30_days: {
        name: '8 - 30 days',
        letter: 'C'
      },
      liquidity_31_to_90_days: {
        name: '31 - 90 days',
        letter: 'D'
      },
      liquidity_91_to_180_days: {
        name: '91 - 180 days',
        letter: 'E'
      },
      liquidity_181_to_365_days: {
        name: '181 - 365 days',
        letter: 'F'
      },
      liquidity_over_365_days: {
        name: 'more than 365 days',
        letter: 'G'
      }
    }
  }
];

export function LiquidityProfiles({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.PORTFOLIO_LIQUIDITY_PROFILE,
    onChangeFund,
    schema: schema.PORTFOLIO_LIQUIDITY_PROFILE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.PORTFOLIO_LIQUIDITY_PROFILE?.field_names || [],
    isSingleData: true,
    isMultiFunds,
    funds,
    tableName: 'PORTFOLIO_LIQUIDITY_PROFILE',
    tables: _tables
  });

  return (
    <StyledTables id="fca-reporttables-liquidity-profiles-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-liquidity-profiles-table-${index + 1}`}
          key={index + 'PORTFOLIO_LIQUIDITY_PROFILE-2'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
